import { Skeleton } from '@/shared/ui/atoms';

export interface ConsolidationStatCardProps {
  /** Rótulo do indicador (ex.: "Total do ano"). */
  readonly label: string;
  /** Valor já formatado — a molécula não formata nada. */
  readonly value: string;
  /** Linha de apoio abaixo do valor; omitida quando ausente. */
  readonly hint?: string | null | undefined;
  /** Exibe skeletons no lugar do valor e da linha de apoio. */
  readonly isLoading?: boolean;
}

/**
 * Um segmento da régua de indicadores da consolidação.
 *
 * Puramente apresentacional: recebe o valor já formatado, sem tocar em
 * `formatCurrency` nem em agregação — os quatro números saem de
 * `deriveConsolidation`, na página.
 *
 * A altura da linha de apoio é reservada mesmo quando ela não existe, para que
 * os quatro valores da régua fiquem na mesma linha de base quando só alguns
 * indicadores têm apoio.
 */
export function ConsolidationStatCard({
  label,
  value,
  hint,
  isLoading = false,
}: ConsolidationStatCardProps) {
  return (
    <div className="flex min-w-none flex-1 flex-col gap-quark px-mini">
      <span className="ts-subtitle-xxs text-ctx-content-placeholder">{label}</span>
      {isLoading ? (
        <>
          <Skeleton className="h-xs w-[9.5rem] rounded-sm" />
          <Skeleton className="h-mini w-[6rem] rounded-sm" />
        </>
      ) : (
        <>
          <span className="ts-heading-md tabular-nums text-ctx-content-title">{value}</span>
          <span className="min-h-mini ts-caption-xxs text-ctx-content-placeholder">
            {hint ?? ''}
          </span>
        </>
      )}
    </div>
  );
}
